<template>
  <div class="row">
    <div class="col-sm-12">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="form-group col-sm-12 col-md-12 required">
            <label for="account_id">Account:</label>
            <Select2 name="account_id" v-model.number="account_id" :options="accountOptions"/>
          </div>          
          <div class="form-group col-sm-12">
            <input class="btn btn-primary" required type="submit" value="Show" :disabled="this.onRequest">
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-12">
      <Datatable v-bind:entries="ceiba_devices" :columns="columns" :title="'Ceiba Devices'"/>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Datatable from '../components/Datatable.vue'
  import { getCapability } from '../_helpers'
  import Select2 from 'vue3-select2-component';
  export default {
    computed: {
      ...mapState('ceiba_devices', ['ceiba_devices', 'onRequest']),
      ...mapState('accounts', ['accounts']),
      ...mapState('users', ['user']),
      columns(){
        return [
            {name: 'terminal_id', text: 'Terminal ID', order: 'asc'},
            {name: 'vehicle', text: 'Vehicle',
              raw: {
                type: 'Sub',
                value: 'vehicle_no'
              }
            },
            {name: 'vehicle', text: 'Vehicle Code',
              raw: {
                type: 'Sub',
                value: 'vehicle_code'
              }
            },
            {name: 'channel', text: 'Channel'},
            {name: 'ceiba_server', text: 'Server Name',
              raw: {
                type: 'Sub',
                value: 'server_name'
              }
            },
            {name: 'action', text: 'Action',
              raw: {
                type: 'Action',
                fields: [
                  getCapability('edit_ceiba_device', this.user) ? {event: 'edit_ceiba_device', text: 'Edit', method: 'get', class: 'btn btn-primary'} : {},
                  getCapability('delete_ceiba_device', this.user) ? {event: 'ceiba_devices/destroy', text: 'Delete', method: 'post', class: 'btn btn-danger ml-1'} : {},
                ]
              }
            },
          ]
      }
    },
    data(){
      return {
        account_id: null,
        accountOptions: []
      }
    },
    components:{
      Datatable,
      Select2,
    },
    methods: {
      ...mapActions('ceiba_devices', ['get_ceiba_device_by_account']),
      ...mapActions('accounts', ['get_all']),
      ...mapActions('alert', ['error', 'clear']),
      handleSubmit(){
        if(this.onRequest) return;
        this.clear()
        this.get_ceiba_device_by_account({account_id: this.account_id})
      },
    },
    created() {
      this.$emit('onChildInit', 'Ceiba Devices', getCapability('add_ceiba_device', this.user) ? '/ceiba_devices/add' : '')
      this.get_all()
    },
    watch: {
      accounts(nextState, prevState){
        if(nextState !== prevState){
          this.accountOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.accountOptions.push({id:item.id, text:item.account_name})
            })
            if(this.accountOptions.length > 0){
              this.account_id = this.accountOptions[0].id
              this.handleSubmit()
            }
          }
          return
        }
      },
    }
  }
</script>
